
class SchemaService {
  constructor() {
    this.data = [];
  }

  setData(newData) {
    this.data = newData || [];
  }

  /**
   * Returns workspace tabs dynamically parsed from JSON.
   * Standard metadata objects with a Section generate their own Tab, using:
   * - Section as the internal unique ID
   * - Description as the visible tab title Name
   * Elements without a Section are grouped under a single dedicated "Schema" tab.
   */
  getWorkspaceTabs() {
    const tabs = [];
    let hasSchemaConfig = false;

    this.data.forEach(item => {
      if (item.Section) {
        let category = 'Other';
        const secLower = item.Section.toLowerCase();
        if (secLower.includes('header')) category = 'Header';
        else if (secLower.includes('body')) category = 'Body';
        else if (secLower.includes('footer')) category = 'Footer';

        let subCategory = category;
        const match = item.Section.match(/^(\d+-[a-zA-Z]+)/);
        if (match) {
            subCategory = match[1];
        }

        tabs.push({
          ...item,
          id: item.Section, // Use Section as the unique internal identifier
          name: item.Description || item.Section, // Use Description as the visible tab title
          category,
          subCategory
        });
      } else {
        hasSchemaConfig = true;
      }
    });

    if (hasSchemaConfig) {
      tabs.push({
        id: 'schema-tab',
        name: 'Schema'
      });
    }

    return tabs;
  }

  /**
   * Gets containers for a given tabId (either a Section identifier or 'schema-tab').
   * - In standard Section tabs, every SourceFields object renders directly as a container.
   * - In the Schema tab, non-section metadata objects render as containers.
   */
  getContainers(tabId) {
    if (tabId === 'schema-tab') {
      const nonSectionItems = this.data.filter(item => !item.Section);
      return nonSectionItems.map((item, idx) => {
        const id = item.SchemaKey || `schema-c-${idx}`;
        const title = item.Type || 'Schema Configuration';
        return {
          id,
          title,
          isCollapsed: false,
          data: item
        };
      });
    } else {
      const item = this.data.find(item => item.Section === tabId);
      if (!item || !item.SourceFields) return [];

      return item.SourceFields.map((f, idx) => {
        const id = f.FieldID?.toString() || `f-${tabId}-${idx}`;
        const title = f.FieldName || 'Unnamed Field';
        return {
          id,
          title,
          isCollapsed: true, // Collapsed by default for a clean initial outline view
          data: f
        };
      });
    }
  }

  /**
   * Reusable method to fetch data directly from a container object.
   */
  getFields(container) {
    return container.data;
  }
}

export const schemaService = new SchemaService();
export default schemaService;
